import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function WalletItemsSkeleton() {
    return (
        <section className="wallet-item-section section-bg">
            <div className="container wallet-container">
                <div className="row gy-3">
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="col-lg-4 col-sm-6">
                            <div
                                className={`wallet-item-card ${
                                    index === 1
                                        ? "two"
                                        : index === 2
                                        ? "three"
                                        : ""
                                }`}
                            >
                                {/* Link Icon */}
                                <div className="wallet-item-card__link">
                                    <span className="wallet-item-card__link-icon">
                                        <Skeleton height={20} width={20} borderRadius={50} />
                                    </span>
                                </div>

                                {/* Content */}
                                <div className="wallet-item-card__content text-center">
                                    <Skeleton height={22} width="60%" borderRadius={6} className="mx-auto mb-2" />
                                    <Skeleton height={48} width="90%" borderRadius={8} className="mx-auto" />
                                </div>

                                {/* Image */}
                                <div className="wallet-item-card__thumb text-center mt-3">
                                    <Skeleton height={327} width={244} borderRadius={16} className="mx-auto" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
